import React from "react";
import { Card, Button, Box, Paper } from "@mui/material";
import Loading from "../../../../components/Common/Loading";

type Props = {
  contratosList: any[];
  contactoLocal: any;
};

const DisplayContractsDesktop: React.FC<Props> = ({
  contratosList,
  contactoLocal,
}) => {
  const openWhatsAppConversation = (action: string, nombreProducto: string) => {
    const text = `Hola, quiero ${action.toLowerCase()} mi suscripción ${nombreProducto}.`;
    const url = `https://api.whatsapp.com/send?phone=${contactoLocal}&text=${encodeURIComponent(
      text
    )}`;
    window.open(url, "_blank");
  };
  return (
    <>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          gap: "10px",
        }}
      >
        {contratosList.map((contrato: any) => (
          <Card
            key={contrato.idContrato}
            variant="outlined"
            sx={{
              px: { md: "3em", xs: "0.5em" },
              display: "flex",
              flexDirection: "column",
              padding: "10px",
              margin: "20px 22px 22px",
              alignItems: "flex-start",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                marginBottom: "10px",
                marginTop: "10px",
              }}
            >
              <Box
                sx={{
                  flexDirection: "column",
                  flexGrow: 1,
                  fontSize: 16,
                  textAlign: "left",
                  whiteSpace: "nowrap", // Prevent wrapping
                }}
              >
                <div style={{ fontSize: "20px", fontWeight: "bold" }}>
                  {contrato.productoNombre}
                </div>
              </Box>

              <div
                style={{
                  backgroundColor: `#${contrato.color}`,
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  padding: "3px 8px",
                  cursor: "pointer",
                  fontSize: "18px",
                }}
              >
                {contrato.estadoNombre}
              </div>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                marginBottom: "10px",
              }}
            >
              <Box
                sx={{
                  flexDirection: "column",
                  flexGrow: 1,
                  fontSize: 16,
                  textAlign: "left",
                  whiteSpace: "nowrap",
                }}
              >
                <div style={{ fontSize: "16px" }}>
                  Desde: {contrato.fechaInicioFormateada}, Hasta:{" "}
                  {contrato.fechaFinFormateada}
                </div>
              </Box>
            </Box>
            {contrato.botonCTA && (
              <Button
                variant="contained"
                color="success"
                fullWidth
                style={{
                  border: "1px solid grey",
                  color: "white",
                  marginTop: "20px",
                }}
                onClick={() =>
                  openWhatsAppConversation(
                    contrato.botonCTA,
                    contrato.productoNombre
                  )
                }
              >
                {contrato.botonCTA}
              </Button>
            )}
          </Card>
        ))}
      </div>
    </>
  );
};

export default DisplayContractsDesktop;
